export default () => jQuery(($) => {
	$('.search-form--minify').addClass('search-form--minified');
	$('.search-form__discloser').click(function () {
		var wrapper = $(this).closest('.search-form');
		wrapper.addClass('search-form--minified-opening').find('.search-form__input[name="q"]').focus();
		window.setTimeout(function () {
			wrapper.addClass("search-form--minified-open");
		}, 10);
	});

	// sync the entry on both search boxes
	var bannerSearchMain = $('.home-page-banner__search .search-form__input');
	var bannerSearchMini = $('.home-page-banner-mini__search .search-form__input');
	bannerSearchMain.change(() => {
		bannerSearchMini.val(bannerSearchMain.val());
	});
	bannerSearchMini.change(() => {
		bannerSearchMain.val(bannerSearchMini.val());
	});

	bannerSearchMini.blur(function () {
		setTimeout(function () {
			$('.home-page-banner-mini').removeClass('home-page-banner-mini--search-expanded');
			$('.home-page-banner-mini__search .search-form').removeClass('search-form--minified-opening').removeClass("search-form--minified-open");
		}, 1200);
	});
});
